import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { validateGUID } from '@wix/cashier-common/dist/src/utils/guid/validateGUID';
import { PaymentsWidgetProps } from '../../../types/PaymentsWidgetProps';
import { wixSdkAdapter } from '../../../utils/wixSdkAdapter';

export const validateProps = (props: PaymentsWidgetProps): void => {
  const {
    singlePaymentMethod,
    allowInPersonPayment,
    allowManualPayment,
    tokenizeMode,
    configuration,
  } = props;

  const unsupportedMethods: PaymentMethod[] = [
    PaymentMethod.Cash,
    PaymentMethod.POS,
    PaymentMethod.SquarePOS,
  ];

  if (unsupportedMethods.includes(singlePaymentMethod)) {
    console.warn(
      `PaymentsWidget: "singlePaymentMethod" property is invalid. Can't have [${unsupportedMethods.toString()}] values.`
    );
  }

  if (singlePaymentMethod === PaymentMethod.InPerson && !allowInPersonPayment) {
    console.warn(
      `PaymentsWidget: "allowInPersonPayment=false" and "singlePaymentMethod=InPerson"  can't be used simultaneously`
    );
  }

  if (singlePaymentMethod === PaymentMethod.Offline && !allowManualPayment) {
    console.warn(
      `PaymentsWidget: "allowManualPayment=false" and "singlePaymentMethod=Offline" can't be used simultaneously`
    );
  }

  if (tokenizeMode) {
    const ignoredPropNames: (keyof PaymentsWidgetProps)[] = [
      'singlePaymentMethod',
      'allowInPersonPayment',
      'allowManualPayment',
      'allowRecurringPaymentOnly',
      'isSaveCCEnabled',
      'mandatoryFields',
      'mandatoryFieldsPrefilled',
      'paymentMethodChanged',
      'creditCardChanged',
    ].filter(
      (propName) =>
        props.hasOwnProperty(propName) && props[propName] !== undefined
    ) as (keyof PaymentsWidgetProps)[];

    if (ignoredPropNames.length > 0) {
      console.warn(
        `PaymentsWidget: ${ignoredPropNames
          .map((propName) => `"${propName}"`)
          .join(', ')} ${
          ignoredPropNames.length === 1 ? 'is' : 'are'
        } ignored when "tokenizeMode" is passed`
      );
    }
  }

  const { visitorId, siteOwnerId } = configuration;

  if (typeof visitorId === 'undefined') {
    if (!wixSdkAdapter.isAvailable()) {
      console.error(
        `PaymentsWidget: missing configuration.visitorId prop and no window.Wix available to perform window.Wix.getInstanceValue('aid') fallback. BI/FTs won't work as expected`
      );
    }
  } else if (!validateGUID(visitorId)) {
    let message: string = `PaymentsWidget: passed prop configuration.visitorId "${visitorId}" is invalid (should be guid)`;

    if (wixSdkAdapter.isAvailable()) {
      message += `. Resolving it via Wix.Utils.getInstanceValue('aid')`;
    }

    console.warn(message);
  }

  if (typeof siteOwnerId === 'undefined') {
    if (!wixSdkAdapter.isAvailable()) {
      console.error(
        `PaymentsWidget: missing configuration.siteOwnerId prop and no window.Wix available to perform window.Wix.Utils.getSiteOwnerId() fallback. BI/FTs won't work as expected`
      );
    }
  } else if (!validateGUID(siteOwnerId)) {
    let message: string = `PaymentsWidget: passed prop configuration.siteOwnerId "${siteOwnerId}" is invalid (should be guid)`;

    if (wixSdkAdapter.isAvailable()) {
      message += `. Resolving it via Wix.Utils.getSiteOwnerId()`;
    }

    console.warn(message);
  }
};
